import React, { useState } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  newAppointmentCategories,
  showAppointmentCategories,
} from '~/config/routes';
import Request from '~/providers/Request';
import AppointmentCategoriesRecord from '~/records/AppointmentCategoriesRecord';
import Form from './Form';

function NewRecord({ history }) {
  const [record, setRecord] = useState(new AppointmentCategoriesRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit(saveAndContinue) {
    const data = record.toParams();

    Request.post(
      '/admin/appointment_categories',
      data,
      {},
      { controller: 'appointmentCategories' }
    )
      .then((resp) => {
        setLoading(false);
        if (saveAndContinue) {
          history.push(newAppointmentCategories.spec);
        } else {
          history.push(showAppointmentCategories.reverse(resp.data));
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes = {
  history: historyPropType,
};

export default NewRecord;
